import React from 'react';
// import CartNotification from 'components/navbar/top/CartNotification';
import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import { Form, Nav } from 'react-bootstrap';
import NineDotMenu from './NineDotMenu';
import { RiUserReceivedFill } from 'react-icons/ri';
import { useAppContext } from 'providers/AppProvider';
import paths from 'routes/paths';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faEnvelope } from '@fortawesome/free-regular-svg-icons';
import ThemeControlDropdown from './ThemeControlDropdown';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { GrAnnounce } from 'react-icons/gr';

const TopNavRightSideNavItem = () => {
  const {
    config: { isDrawerOpen },
    setConfig
  } = useAppContext();
  const { locationArray, location, organization, updateValues } = useAuth();
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <Form.Select
        onChange={e => {
          if (e.target.value !== '') {
            updateValues(locationArray, e.target.value, organization);
          } else {
            updateValues(locationArray, e.target.value, organization);
          }
        }}
        size="sm"
        value={location}
        className="mx-1"
      >
        {/* <option value="">All</option> */}
        {locationArray?.map(option => (
          <option key={option?.location}>{option?.location}</option>
        ))}
      </Form.Select>
      <ThemeControlDropdown />
      {/* <CartNotification /> */}
      <Link to={paths.nursd_announcements}>
        <GrAnnounce size={20} color="#6C6E71" className="mx-1" />
      </Link>
      <Link to={paths.chat}>
        <FontAwesomeIcon
          icon={faComments}
          transform="shrink-6"
          className="fs-5"
          color="#6C6E71"
        />
      </Link>
      <Link to={paths.emailInbox}>
        <FontAwesomeIcon
          icon={faEnvelope}
          transform="shrink-6"
          className="fs-5"
          color="#6C6E71"
        />
      </Link>
      <NotificationDropdown />
      <NineDotMenu />
      <ProfileDropdown />
      <div
        style={{
          background: '#002966',
          padding: 5,
          marginLeft: 5,
          borderTopLeftRadius: 20,
          borderBottomLeftRadius: 20
        }}
      >
        <RiUserReceivedFill
          size={20}
          className="mx-2"
          style={{ cursor: 'pointer', color: 'white' }}
          onClick={() => setConfig('isDrawerOpen', !isDrawerOpen)}
        />
      </div>
    </Nav>
  );
};

export default TopNavRightSideNavItem;
